import { useContext } from 'react'
import _isEmpty from 'lodash/isEmpty'
import _flatten from 'lodash/flatten'
import SlotDateContext from 'context/ProviderBooking/SlotDate'
import ProviderSlotContext from 'context/ProviderBooking/ProviderSlots'
import { ProviderFilterTypes } from 'dataSource/ProviderSearch'
import useAppSelector from 'hooks/useAppSelector'
import { parseProviderDataWithSlots } from './helper'
import { useRouter } from 'next/router'
import { TimeOfDay, DayOfWeek } from 'constants/common'
import { INTAKE_BOOKING_WINDOW_HOURS } from 'constants/common'

type UseShownSlotsProps = (
  slotsRowLimit?: number,
  providersList?: Provider[],
  slotDateData?: SlotDateType,
  providerSlotData?: ProviderScheduleDetails,
  timeZone?: string,
  extendedBookingEnabled?: boolean
) => {
  providerCardDetails: ProviderCardDetails[]
  countDetails: CountDetails
  slotDateData?: SlotDateType
  providerSlotData?: ProviderScheduleDetails
}

const useShownSlots: UseShownSlotsProps = (
  slotsRowLimit = 0,
  providersList = [],
  slotDateData,
  providerSlotData,
  timeZone,
  extendedBookingEnabled = false
) => {
  const { query } = useRouter()
  const { startSlotDate, slotListLimit } =
    slotDateData || useContext(SlotDateContext)
  const { globalGroupedFilters } = useAppSelector((state) => state.global)
  const counselingTypedFilters =
    globalGroupedFilters[ProviderFilterTypes.COUNSELING_TYPE]
  const {
    error,
    loading: areSlotsLoading,
    nextAvailabilityForProviders,
    providerSlots,
  } = providerSlotData || useContext(ProviderSlotContext)
  const bookingWindowHours = INTAKE_BOOKING_WINDOW_HOURS

  const validTimeOfDay = Object.values(TimeOfDay) as string[]
  const validDayOfWeek = Object.values(DayOfWeek) as string[]

  const timeOfDayInQuery = query['timeOfDay[]']
  const timeOfDay = timeOfDayInQuery
    ? (Array.isArray(timeOfDayInQuery)
        ? timeOfDayInQuery
        : [timeOfDayInQuery]
      ).filter((v): v is TimeOfDay => validTimeOfDay.includes(v))
    : undefined

  const dayOfWeekInQuery = query['dayOfWeek[]']
  const dayOfWeek = dayOfWeekInQuery
    ? (Array.isArray(dayOfWeekInQuery)
        ? dayOfWeekInQuery
        : [dayOfWeekInQuery]
      ).filter((v): v is DayOfWeek => validDayOfWeek.includes(v))
    : undefined

  return parseProviderDataWithSlots({
    providerSlots,
    providersList,
    nextAvailabilityForProviders,
    startSlotDate,
    slotListLimit,
    counselingTypedFilters,
    slotsRowLimit,
    error,
    areSlotsLoading,
    timeOfDay,
    dayOfWeek,
    timeZone,
    bookingWindowHours,
    extendedBookingEnabled,
  })
}

export default useShownSlots
